// extracted by mini-css-extract-plugin
export default {"list":"PrivateQuestionList_list__-NIL5","list_item":"PrivateQuestionList_list_item__6S1C4","list_active":"PrivateQuestionList_list_active__mRk6F"};